export { default } from './part-map';